import {
  CurrentResultsWrapper,
  PaginatorWrapper,
  RowsPerPageWrapper,
  PagingText,
} from "./PaginatorStyles";
import BiDropdown from "../dropdowns/BiDropdown.primitive";
import styled from "styled-components/macro";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../app/hooks";
import { convertArrToString } from "../../../util/table-utils";
import { AppConstants } from "../../../constants/AppConstants";

type Props = {
  onSizeChanged: any;
  size: string;
  currentPage: string;
  pagingData?: any;
  refreshPaginatedData?: any;
  containerClass?: string;
  theme?: any;
};
const Paginator = ({
  onSizeChanged,
  size,
  currentPage,
  pagingData,
  refreshPaginatedData,
  containerClass,
  theme,
}: Props) => {
  const sizeChanged = (newSize: string) => {
    onSizeChanged(currentPage, newSize);
  };
  const { t } = useTranslation();

  return (
    <StyledPaginatorWrapper>
      <RowsPerPageWrapper> {t("T_ROWS_PER_PAGE")}</RowsPerPageWrapper>

      <BiDropdown
        options={AppConstants.DEFAULT_PAGE_SIZES.map(String)}
        onSelectedOptionChange={sizeChanged}
        value={size}
        containerClassName={containerClass}
        menuPositionTop={true}
      />

      <CurrentResultsWrapper>
        {pagingData?.size
          ? `${t("T_SHOWING")} ${
              parseInt(size) * (parseInt(currentPage) - 1) + 1
            } -
        ${parseInt(size) * (parseInt(currentPage) - 1) + pagingData?.size}`
          : ""}
      </CurrentResultsWrapper>
      <RowsPerPageWrapper>
        {pagingData?.previous && (
          <PagingText
            onClick={() => {
              refreshPaginatedData(parseInt(currentPage) - 1);
            }}
            theme={theme}
          >
            {t("T_PREVIOUS")}
          </PagingText>
        )}
        {pagingData?.previous &&
          pagingData?.next &&
          pagingData?.size === parseInt(size) &&
          "-"}
        {pagingData?.next && pagingData?.size === parseInt(size) && (
          <PagingText
            onClick={() => {
              refreshPaginatedData(parseInt(currentPage) + 1);
            }}
            theme={theme}
          >
            {t("T_NEXT")}
          </PagingText>
        )}
      </RowsPerPageWrapper>
    </StyledPaginatorWrapper>
  );
};

const StyledPaginatorWrapper = styled(PaginatorWrapper)`
  .mt-4 {
    margin-top: 0 !important;
  }
`;
export default Paginator;
